/* eslint-disable react/forbid-dom-props, object-curly-newline */
import React from 'react';

export const WhiteoutWrapper = ({children}) => (
    <div style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, backgroundColor: '#fff'}}>
        <div style={{position: 'relative', left: 0, right: 0, top: '50%', transform: 'translateY(-50%)'}}>
            <div style={{margin: '0 auto', maxWidth: '33%'}}>
                {children}
            </div>
        </div>
    </div>
);

export default WhiteoutWrapper;
